
import './style.scss';
import { Avatar, Box, Divider, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import { useLanguageContext } from '../../contexts/LanguageContext';
import IServiceOrder from '../../interfaces/IServiceOrder';
import { ServicePriorityData, ServicePriorityEnum, ServiceStatusData, ServiceStatusEnum } from '../../data/Enums';



interface IServiceOrdersListProps {
    items: IServiceOrder[];
    actions?: (item: IServiceOrder) => JSX.Element | JSX.Element[];
}


const ServiceOrdersList: React.FC<IServiceOrdersListProps> = ({
    items,
    actions = undefined
}) => {
    const { translate } = useLanguageContext();

    return <>
        <List className='itemslist-default serviceorder-itemslist'>
            {
                items.map((item, index) => {
                    const status = ServiceStatusData[item.statusId as ServiceStatusEnum];
                    const priority = ServicePriorityData[item.priorityId as ServicePriorityEnum];

                    return <>
                        {
                            index > 0 && <Divider variant="inset" component="li" />
                        }

                        <ListItem 
                            className={`item`} 
                            key={item.id} 
                        >
                            <ListItemAvatar>
                                <Avatar 
                                    className='item-avatar' 
                                    sx={{
                                        color: `#fff !important`,
                                        backgroundColor: `${priority.color} !important`
                                    }}
                                > 
                                    <priority.Icon /> 
                                </Avatar>
                            </ListItemAvatar>

                            <ListItemText 
                                primary={`# ${item.id}`} 
                                secondary={<>
                                    <Typography className='fontsize-14 display-flex alignitems-center gap-6' color={status.color}>
                                        <status.Icon className='fontsize-14' />
                                        {translate(status.name)}
                                    </Typography>
                                </>} 
                                className='item-title' 
                            />

                            <Box className='item-actions'> 
                                {actions && actions(item)}
                            </Box>
                        </ListItem>
                    </>;
                })
            }
        </List>
    </>;
}

export default ServiceOrdersList;